import { useFormat } from '@ideavivat/vivat-2';
import useWithdraw from '@/use/useWithdraw';

import { bomItemMaterialBrand } from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    bom_item: {
      name: 'Job Sub',
      width: '6rem',
      filter: (val: any) => `${val?.job_no || ''}`,
    },
    'bom_item.production_type': {
      name: 'ประเภท',
      width: '6rem',
    },
    'bom_item.material.code': {
      name: 'รหัสชิ้นส่วน',
      width: '1fr',
    },
    'bom_item.description': {
      name: 'รายละเอียด',
      width: '1fr',
    },
    bomItemMaterialBrand,
    'bom_item.drawing_no': {
      name: 'Drawing No./Part No.',
      width: '10rem',
    },
    neededAmount: {
      name: 'จำนวนที่ขอเบิก',
      width: '7rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    filledAmount: {
      name: 'เบิกไปแล้ว',
      width: '5rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    amount: {
      name: 'จำนวนที่ขอเบิก',
      width: '7rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
      class: 'text-center',
    },
  },
};
